import ImageNews from '../images/Book.jpg'

export const NewsData = {
  heading: "Kreuzfahrtgeschichten und 102 schönste Orte",
  paragraphOne: "Es ist geschafft! Während der langen Zeit, in der das Coronavirus die Welt beherrschte, habe ich mir die Zeit damit vertrieben, besondere Geschichten und Ereignisse, die sich während meiner Zeit als Lektor auf verschiedensten Kreuzfahrtschiffen ereigneten, niederzuschreiben. Zunächst nur als Zeitvertreib, aus Spaß an der Freude. Irgendwann reifte dann die Idee heran, dass man daraus ein Buch machen könnte. Und jetzt, zwei Jahre später, ist wirklich ein Buch daraus geworden.",
  paragraphTwo: "Zu beziehen über die ISBN-Nummer: 978-3-7562-1497-6 für 9,99 €.",
  buttonLabelBook: "Jetzt kaufen",

  image: ImageNews,
  reverse: false,
  delay: 100,
}